import { InvestorRole } from "../types/ImportedInvestorEntry";

export function mapInvestorRoleToText(role: InvestorRole) {
  switch (role) {
    case InvestorRole.VC:
      return "VC";
    case InvestorRole.ANGEL:
      return "Angel";
    case InvestorRole.FUND:
      return "Fund";
    case InvestorRole.ACCELERATOR:
      return "Accelerator";
    case InvestorRole.INCUBATOR:
      return "Incubator";
    case InvestorRole.CORPORATE:
      return "Corporate";
    case InvestorRole.FAMILY_OFFICE:
      return "Family Office";
    case InvestorRole.OTHER:
      return "Other";
    default:
      return "Unknown";
  }
}
